/* eslint-disable react/jsx-props-no-spreading */
import Box, { BoxProps } from '@mui/material/Box';
import { capitalize } from 'lodash';
import { MouseEvent, ReactElement } from 'react';
import { Application } from '../../../../types';
import AlternativeEnvironmentButtonFactory from './components/AlternativeEnvironmentButtonFactory';
import Tile from './components/Tile';
import { BACKGROUND_COLORS, LOGOS } from './contants';
import {
  hasAcceptanceEnvironments,
  hasAlternativeEnvironments,
  hasDevelopmentEnvironments,
  hasProductionEnvironments,
  hasTestingEnvironments,
} from './utils';
import DefaultVariant from './variants/DefaultVariant';
import { VariantProps } from './variants/types';
import WideVariant from './variants/WideVariant';

export interface ApplicationTileProps {
  application: Application;
  gridArea: string;
  variant?: 'default' | 'wide' | 'dense';
  sx?: BoxProps['sx'];
}

export default function ApplicationTile({
  application,
  gridArea,
  variant = 'default',
  sx = {},
}: ApplicationTileProps): ReactElement {
  const { name, title, tooltipText, url } = application;

  const backgroundColor = BACKGROUND_COLORS[name];
  const logo = LOGOS[name];

  const openProductionVersion = (e: MouseEvent) => {
    window.open(url, '_blank');

    e.stopPropagation();
  };

  const variantProps: VariantProps = {
    name,
    title,
    logo,
  };

  return (
    <Tile
      title={
        tooltipText ||
        `Klik hier om de productie omgeving van ${
          title || capitalize(name)
        } te openen`
      }
      gridArea={gridArea}
      backgroundColor={backgroundColor}
      onClick={openProductionVersion}
      sx={{
        ...sx,
        flexDirection: 'column',
        p: { xs: 5, sm: 2 },
        paddingTop: ({ spacing }) =>
          hasAlternativeEnvironments(application)
            ? { xs: 5, sm: `max(${spacing(2)}, 60px)` }
            : undefined,
        paddingBottom: { xs: 5, sm: 3 },
      }}
    >
      {variant === 'default' && <DefaultVariant {...variantProps} />}
      {variant === 'wide' && <WideVariant {...variantProps} />}

      {hasAlternativeEnvironments(application) && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            pr: { xs: '5%', sm: '2%' },
            pt: 2,
            pb: 1,
            pl: 1,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1,
            cursor: 'auto',
          }}
          onMouseOver={(e) => {
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
        >
          {hasDevelopmentEnvironments(application) && (
            <AlternativeEnvironmentButtonFactory
              environment={application.alternativeEnvironments.development}
              dtapStep="development"
              appName={application.name}
              appTitle={application.title}
            />
          )}
          {hasTestingEnvironments(application) && (
            <AlternativeEnvironmentButtonFactory
              environment={application.alternativeEnvironments.testing}
              dtapStep="testing"
              appName={application.name}
              appTitle={application.title}
            />
          )}
          {hasAcceptanceEnvironments(application) && (
            <AlternativeEnvironmentButtonFactory
              environment={application.alternativeEnvironments.acceptance}
              dtapStep="acceptance"
              appName={application.name}
              appTitle={application.title}
            />
          )}
          {hasProductionEnvironments(application) && (
            <AlternativeEnvironmentButtonFactory
              environment={application.alternativeEnvironments.production}
              dtapStep="production"
              appName={application.name}
              appTitle={application.title}
            />
          )}
        </Box>
      )}

      {/* {variant === 'default' && <DefaultVariant {...variantProps} />}

      {variant === 'dense' && <DenseVariant {...variantProps} />}

      {variant === 'wide' && <WideVariant {...variantProps} />}

      {hasAlternativeEnvironments(application) && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            pt: ({ spacing }) => spacing(2),
            pr: ({ spacing }) => spacing(2),
            pb: ({ spacing }) => spacing(1),
            pl: ({ spacing }) => spacing(1),
            display: 'flex',
            flexDirection: isSmallerThanSmallScreen ? 'column' : 'row',
            gap: 1,
            cursor: 'auto',
          }}
          onMouseOver={(e) => {
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
        >
          {hasDevelopmentEnvironments(application) && (
            <AlternativeEnvironmentButtonFactory
              environment={application.alternativeEnvironments.development}
              dtapStep="development"
              appName={application.name}
              appTitle={application.title}
            />
          )}
          {hasTestingEnvironments(application) && (
            <AlternativeEnvironmentButtonFactory
              environment={application.alternativeEnvironments.testing}
              dtapStep="testing"
              appName={application.name}
              appTitle={application.title}
            />
          )}
          {hasAcceptanceEnvironments(application) && (
            <AlternativeEnvironmentButtonFactory
              environment={application.alternativeEnvironments.acceptance}
              dtapStep="acceptance"
              appName={application.name}
              appTitle={application.title}
            />
          )}
          {hasProductionEnvironments(application) && (
            <AlternativeEnvironmentButtonFactory
              environment={application.alternativeEnvironments.production}
              dtapStep="production"
              appName={application.name}
              appTitle={application.title}
            />
          )}
        </Box>
      )} */}
    </Tile>
  );
}
